import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { userMainSection } from "./userMainSection";
import { hubSpotContactSection } from "HubSpot/HubSpotContactPanel";
import UserDetailOptionsPanel from "./UserDetailOptionsPanel";
import { useLoaderData } from "react-router";

const AdminOneUserApp = () => {
  const viewModel = useLoaderData<server.viewmodel.UserForAdminOneFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <SectionPanel.Section>
        <DetailSectionTemplate
          onValueChanged={() => { }}
          sections={[
            userMainSection({ user: viewModel.user }),
            hubSpotContactSection({ hubSpotContactId: viewModel.user.hubSpotContactId, userId: viewModel.user.userId }),
          ]}
          isInPageEditable={false}
        />
      </SectionPanel.Section>
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>

      <UserDetailOptionsPanel
        optionsPanel={viewModel.optionsPanel}
        listUrl={viewModel.listUrl}
        userId={viewModel.user.userId}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}

export default AdminOneUserApp;